export const getInventoryRackList = state => {
    return state.list
}

export const getInventoryRackDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryRack/getters.js